// extracted by mini-css-extract-plugin
module.exports = {"row":"CredentialLine_row__30eWk","nameColumn":"CredentialLine_nameColumn__CShBM","nameColumnText":"CredentialLine_nameColumnText__1yS0u"};